import images from "../Images"
import info from "../Info"

const friends = {
  //name : ['friendName', 'image', 'date', 'mult1', 'mult2', 'rDate', 'story']
    user: [info.username, info.user_pfp],
    tobio : ['Tobio Sukehiro', images.ayanami1, '2d', images.artisan1, images.floppus, '101', images.nature1],
    ken : ['Ken', images.rest_here, '51m', images.ayanami1, images.aruma1, '54', images.ronaldo1],
    voizone : ['Voizone Gtx', images.mewing_cat, '2d', images.artisan2, images.floppa1, '12', images.abyss_meme],
    saida : ['Saida', images.ayanami2, '3d', images.didin1, images.floppus, '45', images.anime_art],
    shizou : ['Shizou', images.ayanami3, '1w', images.rest_here, images.mewing_cat, '34', images.artisan2],
    dante : ['dante愛', images.cmGirl1, '14m', images.cmGirl1, images.cgarou1, '87', images.abyss_meme],
    kai : ['Kai愛', images.cgarou1, '36m', images.mewing_cat, images.floppus, '64', images.musicsCover],
    azossama : ['Az Ossama', images.bugs_bunny, '1d', images.red_pixel, images.floppus, '245', images.abyss_meme],
    didin : ['Didin Clash', images.didin1, '1m', images.ayanami3, images.red_pixel, '99', images.makima1],
    aymendjf : ['Aymen Djeffal', images.artisan2, '1y', images.artisan1, images.floppus, '134', images.abyss_meme],
    floppa : ['Floppa', images.floppa1, '17s', images.aruma1, images.ayanami3, '20', images.opmanga3],
    kaori : ['Kaori', images.itadori1, '1h', images.ayanami3, images.bugs_bunny, '11', images.abyss_meme],
    aruma : ['Aruma', images.aruma1, '5h', images.floppus, images.itadori1, '50', images.abyss_meme],
}

export default friends